import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { getCurrencyCodeFromCountryCode } from '../../../common/currency';
import { useGetSessionCompany } from '../../../common/hooks/useGetSessionCompany';
import { CompanyProductFreeTrialOffer } from '../../../common/interfaces/product-free-trial-offer';
import { timePeriodUnitToText } from '../../../modules/CreditSystem/constants';

type Props = {
  vipOffer: CompanyProductFreeTrialOffer;
};

export default function VIPFreeTrialCTAText({ vipOffer }: Props) {
  const { formatMessage, formatNumber } = useIntl();

  const { sessionCompany } = useGetSessionCompany();
  const currencyCode = getCurrencyCodeFromCountryCode(
    sessionCompany?.CountryCode
  );

  if (!vipOffer.productTimePeriod || !vipOffer.productTimePeriodUnit) {
    return null;
  }

  return (
    <FormattedMessage
      id="interactive-try-count-days-for"
      defaultMessage="Try {count} {timeUnit} for {amount}"
      values={{
        count: vipOffer.productTimePeriod,
        timeUnit: formatMessage(
          timePeriodUnitToText[vipOffer.productTimePeriodUnit],
          {
            count: vipOffer.productTimePeriod,
          }
        ),
        amount: formatNumber(0, {
          currency: currencyCode,
          style: 'currency',
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 0,
        }),
      }}
    />
  );
}
